import { CompCheckboxCore } from '../core/forms/checkbox/comp'

export const CompCheckbox = CompCheckboxCore
